import { navigateTo } from "../framework/router.ts";

export default function RegisterPage() {
  const container = document.createElement("div");
  container.innerHTML = `
    <h1>Register</h1>
    <p>Registration form here</p>
    <button id="loginLink">Go to Login</button>
  `;

  container.querySelector("#loginLink").addEventListener("click", () => {
    navigateTo("/login");
  });

  return container;
}
